import { render, staticRenderFns } from "./SalesCustomer.vue?vue&type=template&id=a3a85674"
import script from "./SalesCustomer.vue?vue&type=script&lang=js"
export * from "./SalesCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports